const initialValue = {
  selectedInvoices: [],
}

export default initialValue
